import { registerRootComponent } from 'expo'
import { ExpoRoot } from 'expo-router'
import { LogBox, Text, TextInput } from 'react-native'

// Disable font scaling globally for Text components
Text.defaultProps = Text.defaultProps || {}
Text.defaultProps.allowFontScaling = false

// Disable font scaling globally for TextInput components
TextInput.defaultProps = TextInput.defaultProps || {}
TextInput.defaultProps.allowFontScaling = false

// Hide the warnings in React Native iOS simulator?
LogBox.ignoreLogs(['Warning: ...', 'This method is deprecated']) // Ignore log notification by message
LogBox.ignoreAllLogs() //Ignore all log notifications

if (__DEV__) {
  console.warn('DISABLING FIREBASE DEPRECATIONS!')
  globalThis.RNFB_SILENCE_MODULAR_DEPRECATION_WARNINGS = true
}

// Must be exported or Fast Refresh won't update the context
export function App() {
  console.info('APP REGISTERED AND STARTING')
  const ctx = require.context('./src/router')
  return <ExpoRoot context={ctx} />
}

registerRootComponent(App)
